<template>
  <div class="md:pb-20 lg:pb-20 relative z-index1 bg-insight-cs1">
    <!-- <ToolsPopup
      :isActive="isDetailsActive"
      :selectedTools="selectedTools"
      @close="toggleDetails"
    /> -->
    <div
      class="absolute insights-bg z-index--1 md:block lg:block md-hidden hidden"
    >
      <img
        src="../../../../assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div>
    <!-- <div class="absolute insights-bg-mob md:hidden lg:hidden block">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->

    <div class="md:pt-0 lg:pt-0 pt-36">
      <div
        class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto md:pt-32 lg:pt-32 pt-6"
      >
        <div
          class="lg:flex md:flex justify-between items-center lg:mt-0 md:mt-0 mt-8"
        >
          <p
            class="title fsize36-16px-isg lg:font-normal md:font-normal font-bold z-10"
          >
            Latest Toolkits
          </p>
          <div class="lg:mt-0 md:mt-0 mt-4 w50perc sm-w100perc">
            <div class="flex text-black">
              <b-form-select
                v-model="selectedTopic"
                class="lg:mr-4 md:mr-4 mr-1 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedCategories"
                class="lg:mr-4 md:mr-4 mr-1 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                ></b-form-select
              >
              <!-- <b-form-select
                v-model="selectedUsers"
                class="border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null" disabled
                  >{{ filters.length ? filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                ></b-form-select
              > -->
              <multiselect
                class="mr-0 lricon"
                v-model="selectedUsers"
                :options="filter3"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Tools"
                track-by="name"
                label="name"
                :preselect-first="false"
              >
              </multiselect>
            </div>
          </div>
        </div>
        <p
          class="text-end text-primary cursor-pointer fsize14 sm-fsize12 font-semibold hov-underline lg:mb-0 md:mb-0 mb-6"
          @click="handleClear"
        >
          Clear Filter
        </p>
        <div class="md:pt-10 lg:pt-10 pt-0" id="toolsList">
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 grid-rows-1 gap-8"
          >
            <div
              class="md:mt-0 lg:mt-0 cursor-pointer rounded-b-lg shadow-xl bg-white blog-tooltip-ui"
              v-for="(item, index) in categorywisepages.data"
              :key="'item -' + index"
              @click="toggleDetails(true, item)"
            >
              <!-- <div
                class="relative"
                v-if="
                  Object.keys(user).length !== 0 &&
                  Object.hasOwn(user, 'currentMembership') &&
                  user.currentMembership.length !== 0 &&
                  user.currentMembership != null &&
                  Object.hasOwn(item, 'memberships') &&
                  item.memberships != null &&
                  Object.keys(item.memberships).length !== 0
                "
              >
                <span class="absolute top-3 left-1 z-index-999">
                  <img
                    class="rounded-full w-6 h-6"
                    :src="$imageURL + '/' + item.memberships[0].image"
                    :style="{}"
                  />
                </span>
              </div> -->
              <div class="relative">
                <span
                  class="absolute top-3 left-3 z-index-999 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
                  v-if="item.onlySubscribed"
                >
                  For Subscribers Only
                </span>
                <span
                  class="absolute top-3 left-3 z-index-999 flex gap-1 bg-ede3fa py-1 px-3 rounded-full fsize15 text-primary"
                  v-if="item.onlyRegistered && !item.onlySubscribed"
                  ><feather-icon icon="UnlockIcon" svgClasses="w-4" />
                  Access Caregiver Saathi
                </span>
              </div>
              <!-- <div
                class="relative"
                v-if="
                  Object.keys(user).length == 0 &&
                  Object.hasOwn(item, 'memberships') &&
                  item.memberships != null &&
                  Object.keys(item.memberships).length !== 0
                "
              >
                <span class="absolute top-3 left-1 z-index-999">
                  <img
                    class="rounded-full w-6 h-6"
                    :src="$imageURL + '/' + item.memberships[0].image"
                    :style="{}"
                  />
                </span>
              </div> -->
              <!-- <span class="blog-tooltiptext-ui" v-if="item.onlySubscribed">
                For {{ item.memberships[0].name }} Only
              </span>
              <span
                class="blog-tooltiptext-ui"
                v-if="item.onlyRegistered && !item.onlySubscribed"
              >
                For Registered Users Only
              </span> -->
              <el-tooltip
                :disabled="!item.onlyRegistered"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <template slot="content">
                  <span class="" v-if="item.onlySubscribed">
                    For {{ item.memberships[0].name }} Only
                  </span>
                  <span
                    class=""
                    v-if="item.onlyRegistered && !item.onlySubscribed"
                  >
                    For Registered Users Only
                  </span>
                </template>
                <div>
                  <img
                    :src="$imageURL + '/' + item.image"
                    v-if="item.image != '' && item.image != undefined"
                    alt="NewsTitle"
                    class="rounded-t-lg h-52 w-full object-contain"
                  />
                  <img
                    v-else
                    :src="
                      $imageURL + '/caregiversaathi/default/dummy%20image.jpg'
                    "
                    alt=""
                  />

                  <div class="p-4">
                    <p
                      class="text-black font-bold cursor-pointer fsize18px sm-fsize14 lh-28"
                    >
                      {{ item.title }}
                    </p>
                    <p
                      class="text-black cursor-pointer fsize10px sm-fsize14 lh-28 ellipsis-2"
                    >
                      {{ item.description }}
                    </p>
                    <div class="md:mt-4 lg:mt-4 mt-2 flex">
                      <p class="text-xs clr777 font-normal">
                        📖 Read Time: {{ item.readTime }} minutes
                      </p>
                      <p class="text-xs clr777 font-normal ml-6">
                        💰 {{ item.paytype }}
                      </p>
                    </div>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="flex lg:mt-8 md:mt-8 mt-4 flex-wrap">
            <b-pagination
              @change="handlePageChange"
              v-model="currentPage"
              pills
              :total-rows="rows"
              :per-page="perPage"
              size="lg"
              class="ml-auto flex flex-wrap"
            ></b-pagination>
          </div>
          <div class="border my-6 rounded-lg p-3 lg:mb-12 md:mb-12">
            <h3 class="fsize22 font-semibold">Disclaimer:</h3>
            <p class="leading-tight fsize16 mt-3 clr-2e2e2e">
              The information provided on this website is for educational
              purposes only and is not intended to be a substitute for
              professional medical advice, diagnosis, or treatment.
            </p>
            <p class="fsize16 mt-2 clr-2e2e2e">
              Readers should seek professional medical advice and treatment for
              any specific health-related issues."
            </p>
            <p class="fsize16 mt-2 clr-2e2e2e">
              The information presented on this website is provided 'as is'
              without any representations or warranties, express or implied. The
              website owner and contributors disclaim all liability for any
              damages or losses arising from the use of this information.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ToolsPopup from "./ToolsPopup.vue";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import _ from "lodash";
export default {
  components: {
    ToolsPopup,
    Multiselect,
  },
  data() {
    return {
      filter1: [],
      filter2: [],
      filter3: [],
      filteredData: [],
      categoryId: null,
      selectedTopic: null,
      selectedUsers: null,
      selectedCategories: null,
      currentPage: 1,
      perPage: 10,
      rows: 0,
      ignorePageChange: false,
      selectedTools: {},
      isDetailsActive: false,
      tagid: [],
      oldTagTopic: "",
      oldTagCategories: "",
      oldTagUser: [],
    };
  },
  watch: {
    async selectedTopic(val) {
      this.tagid = this.tagid.filter((tag) => tag !== this.oldTagTopic);
      this.oldTagTopic = val;
      // console.log(val);
      if (val !== null) {
        this.tagid.unshift(val);
      }
      if (val || val === null) {
        await this.fetchTools({ resetPage: true });
        this.loadData();
      }
    },
    async selectedCategories(val) {
      this.tagid = this.tagid.filter((tag) => tag !== this.oldTagCategories);
      this.oldTagCategories = val;
      if (val !== null) {
        this.tagid.unshift(val);
      }
      if (val || val === null) {
        await this.fetchTools({ resetPage: true });
        this.loadData();
      }
    },
    async selectedUsers(val) {
      // console.log(val);
      // if (val) {
      //   this.loadData();
      // }
      let tagIdData = Array.isArray(val) ? val.map((tag) => tag._id) : [];
      // console.log(tagIdData, "***********");

      // this.tagid = this.tagid.filter((tag) => tag !== this.oldTagUser);
      this.tagid = this.tagid.filter((tag) => !this.oldTagUser.includes(tag));
      this.oldTagUser = tagIdData;
      if (tagIdData !== null) {
        // this.tagid.unshift(tagIdData);
        this.tagid = [...this.tagid, ...tagIdData];
      }
      // console.log(this.tagid);
      if (val || val === null) {
        await this.fetchTools({ resetPage: true });
        this.loadData();
      }
    },
    categorywisepages(val) {
      if (this.tagid.length > 0) {
        this.categorywisepages = { ...this.categorywisepages };
      }
    },
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),

    displayedPages() {
      return this.pages.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    total_row() {
      return this.pages.length.toString();
    },
  },
  methods: {
    async fetchTools({ resetPage = false } = {}) {
      if (resetPage && this.currentPage !== 1) {
        this.ignorePageChange = true;
        this.currentPage = 1;
        this.$nextTick(() => {
          this.ignorePageChange = false;
        });
      }

      const payload = {
        offset: Math.max(0, (this.currentPage - 1) * this.perPage),
        limit: this.perPage,
        id: this.categoryId,
        updatedAt: true,
      };
      if (this.tagid.length > 0) {
        payload.tagid = this.tagid;
      }

      const filteredAPIData = await this.$store.dispatch(
        "cms/getpagebycategory",
        payload
      );
      const pageResult =
        filteredAPIData && filteredAPIData.data ? filteredAPIData.data : {};
      this.filteredData = pageResult;
      this.rows = Number(pageResult.totalPages || pageResult.totalCount) || 0;
      return pageResult;
    },
    async handlePageChange(value) {
      this.currentPage = value;
      if (this.ignorePageChange) return;
      await this.fetchTools();
      const el = document.getElementById("toolsList");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    toggleDetails(val = false, item = {}) {
      console.log("toggleDetails", val, item);
      try {
        // console.log(this.categorywisepages.data);
        let clickedBlogId = "";
        if (Object.keys(this.user).length !== 0) {
          this.categorywisepages.data.forEach((element) => {
            if (element._id === item._id) {
              if (
                element.memberships != null &&
                element.memberships.length !== 0
              ) {
                clickedBlogId = element.memberships[0]._id;
              }
            }
          });
        }
        if (item.onlyRegistered) {
          if (Object.keys(this.user).length === 0) {
            this.$router.push({ name: "signin" });
            Swal.fire({
              title: "Login",
              text: "To access the content, kindly proceed with registration/login",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showConfirmButton: true,
            });
            return;
            //   .then((result) => {
            //   if (result.isConfirmed) {
            //     this.$router.push({ name: "signin" });
            //   }
            // });
          } else if (item.onlySubscribed) {
            if (
              this.user.membership != null &&
              this.user.membership.includes(clickedBlogId)
            ) {
              const routeData = this.$router.resolve({
                name: "ToolsPage",
                params: {
                  id: item._id,
                  // slug: this.item._id,
                  slug: this.encodeURIBlog(item.title),
                  // category: this.category,
                },
              });
              window.open(routeData.href, "_blank");
              this.isDetailsActive = val;

              this.selectedTools = item;
            } else {
              Swal.fire({
                title: "Subscribe",
                text: "Please Subscribe to our membership to view the Self-Help Tool",
                icon: "warning",
                confirmButtonColor: "#830c81",
                confirmButtonText: "Show Plans",
                showConfirmButton: true,
                showCancelButton: true,
              }).then((e) => {
                if (e.isConfirmed) {
                  this.$router.push({
                    path: "/subscribe1",
                    // query: { buymembership: true },
                  });
                }
              });
            }
          } else {
            this.isDetailsActive = val;

            this.selectedTools = item;
          }
        } else {
          // this.isDetailsActive = val;
          // this.selectedTools = item;
          const routeData = this.$router.resolve({
            name: "ToolsPage",
            params: {
              id: item._id,
              // slug: this.item._id,
              slug: this.encodeURIBlog(item.title),
              // category: this.category,
            },
          });
          window.open(routeData.href, "_blank");
        }
        // this.isDetailsActive = val;

        // this.selectedTools = item;
        // console.log(this.selectedTools);
      } catch (error) {
        console.log(error);
      }
    },
    encodeURIBlog(string) {
      // return encodeURI(string);
      // return string.replace(/-/g, "_").replace(/\s/g, "-");
      return encodeURIComponent(
        string.trim().replace(/-/g, "_").replace(/\s+/g, "-")
      );
    },
    handleClear() {
      this.selectedTopic = null;
      this.selectedUsers = null;
      this.selectedCategories = null;
      this.init();
    },
    async loadData() {
      let loader = this.$loading();
      try {
        let categoryUsers = [],
          categoryTopics = [],
          category = [];
        if (this.selectedUsers != null)
          categoryUsers = this.categorywisepages.data.filter((x) => {
            return x.tags.includes(this.selectedUsers);
          });
        if (this.selectedCategories != null)
          category = this.categorywisepages.data.filter((x) => {
            return x.tags.includes(this.selectedCategories);
          });
        if (this.selectedTopic != null)
          categoryTopics = this.categorywisepages.data.filter((x) => {
            return x.tags.includes(this.selectedTopic);
          });

        let combinedFilter = [...categoryUsers, ...category, ...categoryTopics];
        this.filteredData = _.uniq(combinedFilter);

        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async init() {
      await this.$store.dispatch("cms/getPageCategories");

      this.pageCategories.forEach((element) => {
        if (element.route.includes("selfhelp")) this.categoryId = element._id;
      });
      await this.$store.dispatch("cms/getTagsbyCategory", {
        categoryPage: this.categoryId,
      });
      await this.$store.dispatch("cms/getfilterbycategory", {
        categoryPage: this.categoryId,
      });
      // console.log(this.filtertags);
      // console.log(this.filters);
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      await this.fetchTools();
    },
    isNotLoggedIn() {
      if (sessionStorage.getItem("token")) {
        return false;
      } else {
        return true;
      }
    },
  },
  async mounted() {
    if (Object.keys(this.user).length !== 0) {
      let getUserPayload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        getUserPayload
      );
    }
    this.init();
  },
};
</script>
<style>
.lricon .multiselect__select {
  right: 12px !important;
  top: 5px !important;
}
.inp-search {
  border-radius: 50px !important;
  border: 1px solid #4f0a4b !important;
  height: 47px !important;
}

.bg-insight-cs1 .multiselect__tags {
  border: 2px solid #4f0a4b;
  border-radius: 7px;
  height: auto;
  width: 200px;
}

.bg-insight-cs1 .multiselect__tag {
  background: #4f0a4b;
  color: #fff;
  margin-bottom: 1px;
}
.bg-insight-cs1 .multiselect__option--highlight {
  background: #4f0a4b;
  color: #fff;
}
.bg-insight-cs1
  .multiselect__option--selected.multiselect__option--highlight:after {
  background: #4f0a4b;
  color: #fff;
}
.bg-insight-cs1 .multiselect__option--highlight:after {
  display: none;
}
.bg-insight-cs1 .multiselect__option--selected.multiselect__option--highlight {
  background: #4f0a4b;
  color: #fff;
}

.w50perc {
  width: 50%;
}

@media (max-width: 641px) {
  .inp-search {
    height: 40px !important;
  }
  .bg-insight-cs1 .multiselect__tags {
    border: 2px solid #4f0a4b;
    border-radius: 7px;
    height: 40px;
    width: auto;
  }
  .lricon .multiselect__select {
    right: 1px !important;
    top: 1px !important;
  }

  .sm-w100perc {
    width: 100%;
  }
}
</style>
